import type { ButtonProps } from 'antd';
import { css, type DefaultTheme, type FlattenInterpolation, type ThemeProps } from 'styled-components';
import { getDangerousButtonStyle } from './getDangerousButtonStyle';

export const getButtonStyleByType = (type: ButtonProps['type']): FlattenInterpolation<ThemeProps<DefaultTheme>> => {
  switch (type) {
    case 'primary':
      return css`
        border-style: none;

        &&&:focus-visible {
          outline-color: ${({ theme }) => theme.color.separators.divider};
          outline-offset: -2px;
        }

        &&&:disabled {
          border-style: none;
        }

        &&&.ant-btn-dangerous {
          border-style: none;
          text-decoration: none;

          &:hover {
            filter: brightness(0.9);
          }
        }
      `;
    case 'text':
      return css`
        border-style: none;

        &&&.ant-btn-dangerous {
          ${getDangerousButtonStyle}
        }

        &&&:hover {
          background-color: ${({ theme }) => theme.color.theme.lighterAlt};
          text-decoration: underline 0.5px;
        }

        &&&:focus-visible {
          color: ${({ theme }) => theme.color.theme.primary};
          outline-color: ${({ theme }) => theme.color.theme.darkAlt};
        }

        &&&:active {
          background-color: ${({ theme }) => theme.color.theme.lighter};
        }

        &&&:disabled {
          background-color: ${({ theme }) => theme.color.grey.grey4};
          border-style: none;
          text-decoration: none;
        }
      `;
    case 'link':
      return css`
        border-color: transparent;
        color: ${({ theme }) => theme.color.theme.primary};

        &&&.ant-btn-dangerous {
          ${getDangerousButtonStyle}

          &:disabled {
            border-style: solid;
            border-color: transparent;
          }
        }

        &&&:hover:not(:disabled) {
          text-decoration: underline;
        }

        &&&:focus-visible {
          outline-color: ${({ theme }) => theme.color.theme.darkAlt};
        }
      `;
    case 'default':
    default:
      return css`
        border: 1px solid ${({ theme }) => theme.color.theme.primary};
        &:focus-visible {
          outline-color: ${({ theme }) => theme.color.theme.darkAlt};
          outline-offset: -3px;
        }

        &:disabled {
          border-style: none;
        }

        &.ant-btn-dangerous {
          color: ${({ theme }) => theme.color.status.error};
          background-color: ${({ theme }) => theme.color.grey.white};
          border: 1px solid ${({ theme }) => theme.color.status.error};

          &:hover {
            background-color: ${({ theme }) => theme.color.semantic.feedback.background.error};
          }
        }
      `;
  }
};
